var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1902.66 969.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .f99ad92e-f88d-4a68-b973-58b2f6eaa4b2{fill:none;}.afcdfc1c-0ed4-4453-9005-87b9f61f33e7{fill:url(#a87b41d4-926e-4dbb-9d33-00c8e0999883);}.a28ec69e-6524-4db4-a858-e8f6a7115ea6{fill:url(#b15696a0-b962-4e43-8518-4267365a9868);}.f73ec09c-d529-4e2c-a7ec-ceb3aeef4559{fill:url(#bd1d5834-8d32-4951-b55b-a2933c3185e6);}.ee883bb1-b911-45ed-a6f2-22338d6edcb8{fill:url(#a7b2c0d8-31fb-4123-9473-4fcf3f472446);}.aa5297ad-23b7-4ff1-865f-114b98dcff8a{fill:#fff;}.f154d60d-414c-45f4-a657-0e1fabe27458{fill:#006a35;}.b5aac3c8-38af-4b9a-8297-d6c52847fb1e{fill:#ffec3b;}.a9acf446-bb36-4ff5-b274-7615b4835329{isolation:isolate;}.ae9a7081-23be-4ed3-91ca-bb295fde1efd{fill:#ffc800;}.f9da365f-698a-4313-a061-67cbdc308e5f{opacity:0.1;}.a9104a1f-e19b-4286-b2e8-cb0fc1455121{clip-path:url(#a0d2af06-4668-4661-b97a-f7932aa6b1a1);}.efeda1ec-0cb8-4457-ba2c-81f46cab70c6{clip-path:url(#bd38d359-5494-4921-8750-9a9c3e46ce5a);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a87b41d4-926e-4dbb-9d33-00c8e0999883",
    x1: -151.17,
    y1: 904.55,
    x2: 889.33,
    y2: 429.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f4ebf0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c9a3b6",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#a66787",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8b3962",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#781948",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6d0639",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a0035"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b15696a0-b962-4e43-8518-4267365a9868",
    x1: 856.27,
    y1: 880.77,
    x2: 1478.3,
    y2: 880.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fff",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fff",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fff",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fff",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fff",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd1d5834-8d32-4951-b55b-a2933c3185e6",
    x1: 663.5,
    y1: 262.92,
    x2: 505.58,
    y2: 457.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fff",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#fff",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fff",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a7b2c0d8-31fb-4123-9473-4fcf3f472446",
    x1: 1133.76,
    y1: 557.62,
    x2: 1516.39,
    y2: 391.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#d0eae9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a4d6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7cc4c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5bb5b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#40a8a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2b9f9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1c9895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#149491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119390"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a0d2af06-4668-4661-b97a-f7932aa6b1a1",
    transform: "translate(-8 -66.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f99ad92e-f88d-4a68-b973-58b2f6eaa4b2",
    d: "M1723.3,629.53v-1a4.44,4.44,0,1,1,8.87,0v1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd38d359-5494-4921-8750-9a9c3e46ce5a",
    transform: "translate(-8 -66.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f99ad92e-f88d-4a68-b973-58b2f6eaa4b2",
    d: "M1732.17,1018v1a4.44,4.44,0,1,1-8.87,0v-1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a035fe3a-0cf9-4513-bc21-0b22e681b844",
    "data-name": "arrow 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fc0ba14c-c0d6-46ba-9c05-b925852fe6a1",
    "data-name": "arrow 1",
    className: "afcdfc1c-0ed4-4453-9005-87b9f61f33e7",
    d: "M719.76,90a428.52,428.52,0,0,0-83.36,8.07l-9.3-21.32a16.53,16.53,0,0,0-28.6-3L567,117.81,498,214.32a16.56,16.56,0,0,0,11.38,26.06l77.5,9.83,93.88,11.84A16.55,16.55,0,0,0,697.91,239L690,221c9.83-1,19.75-1.49,29.75-1.49C887,219.5,1022.47,355,1022.47,522.21a297.84,297.84,0,0,1-24,117.67c-43.76,101-141.25,165.8-209.57,172.93-10.21,1.06-42.12,3.17-77.18,4.06-25.93.65-47.09.48-60.66.24H114.39A106.38,106.38,0,0,0,8,923.49H8a20.84,20.84,0,0,0,20.84,20.84H808.47a49.16,49.16,0,0,1,5.58-.59c1.15-.29,2.33-.52,3.55-.72A432.28,432.28,0,0,0,1152,522.21C1152,283.46,958.5,90,719.76,90Z",
    transform: "translate(-8 -66.84)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "acb48e49-a9e6-45af-99ec-6ce1092d8f7c",
    "data-name": "arrow 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f8bfb77d-35c9-4ea2-85fd-129f0ca6bd2b",
    "data-name": "arrow 2_1",
    className: "a28ec69e-6524-4db4-a858-e8f6a7115ea6",
    d: "M1555.5,899.06l-150.74,84.58a16.54,16.54,0,0,1-24.66-14.83l.38-14.94a9.3,9.3,0,0,0-9.3-9.54H951.23c-9.76,0-13-13.23-4.24-17.56a431.66,431.66,0,0,0,123.65-92.12c4.37-4.66,8.63-9.44,12.78-14.29a9.2,9.2,0,0,1,7-3.25h284.65a9.3,9.3,0,0,0,9.3-9.05l.45-16.22a16.54,16.54,0,0,1,25.36-13.52l146,92.31A16.57,16.57,0,0,1,1555.5,899.06Z",
    transform: "translate(-8 -66.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f6ec6f86-b94d-44d0-896c-f329e8154355",
    "data-name": "arrow 2_2",
    className: "f73ec09c-d529-4e2c-a7ec-ceb3aeef4559",
    d: "M526.21,782H380.61a12,12,0,0,1-9.63-4.83A429.35,429.35,0,0,1,287.72,522.3c0-156.1,82.65-292.89,206.63-368.78,6.23-3.86,13.16,3.68,8.86,9.56l-47.9,64.32c-9.66,13-2.72,31.41,12.72,33.6l64.58,9.39a6.52,6.52,0,0,1,3.07,11.67,302.56,302.56,0,0,0-2.35,478.65C542.29,767.71,537.59,782,526.21,782Z",
    transform: "translate(-8 -66.84)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "a7b7b6e3-ab09-45ef-8a41-f88225a149f0",
    "data-name": "arrow3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fa16d7ac-379a-472e-a750-93c65837d008",
    "data-name": "arrow 3",
    className: "ee883bb1-b911-45ed-a6f2-22338d6edcb8",
    d: "M1537.86,568.45l-113.1,112a15.23,15.23,0,0,1-25.35-6.5L1354.57,521a15.27,15.27,0,0,1,18.51-19l13.52,3.51c-3-49.31-33.52-94.15-80-113.8-43.55-18.42-93.14-11.5-130,15.82-6.36,4.72-15.51,2.19-17.86-5.38a424.17,424.17,0,0,0-32-76,11.31,11.31,0,0,1,4.21-15.32c39.34-22.54,138.54-68.08,237.07-15.61,74.32,39.57,105.21,110.38,114.07,131.61a280.46,280.46,0,0,1,21.67,109v.09l27.29,7A15.27,15.27,0,0,1,1537.86,568.45Z",
    transform: "translate(-8 -66.84)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "bfda95f5-c8b0-43d7-ae4d-e4121a37205c",
    "data-name": "clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa3de88d-92ac-493a-8738-d17486df5e94",
    "data-name": "clock_bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "a826d2ff-ac8e-4eec-98ab-0d520a906c67",
    "data-name": "clock_bg_1",
    className: "aa5297ad-23b7-4ff1-865f-114b98dcff8a",
    cx: 707.66,
    cy: 523.26,
    r: 153.72,
    transform: "translate(-170.73 586.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "afac1599-06a2-4ed2-8512-9a06108b0e99",
    "data-name": "clock_bg_2",
    className: "f154d60d-414c-45f4-a657-0e1fabe27458",
    d: "M707.66,690C615.74,690,541,615.19,541,523.25s74.78-166.7,166.7-166.7,166.71,74.78,166.71,166.7S799.58,690,707.66,690Zm0-307.44c-77.6,0-140.72,63.13-140.72,140.72S630.06,664,707.66,664s140.73-63.14,140.73-140.74S785.26,382.53,707.66,382.53Z",
    transform: "translate(-8 -66.84)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a435ce79-a027-4b62-aaf2-c5b6edb0e4b0",
    "data-name": "time",
    className: "b5aac3c8-38af-4b9a-8297-d6c52847fb1e",
    d: "M712.46,531.77,831.08,488.5s-33-96.25-121.57-93.9Z",
    transform: "translate(-8 -66.84)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e48aabc0-cddb-4247-bb65-284738c28ae6",
    "data-name": "second",
    className: "f154d60d-414c-45f4-a657-0e1fabe27458",
    x: 693.17,
    y: 337.62,
    width: 12.99,
    height: 158.32,
    rx: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd0b8329-927a-42f4-89b2-77a576d99afe",
    "data-name": "hour",
    className: "f154d60d-414c-45f4-a657-0e1fabe27458",
    d: "M768.39,516.12l-1.59-4.34a4.2,4.2,0,0,0-5.37-2.49l-83.37,30.56a4.2,4.2,0,0,0-2.49,5.37l1.59,4.34a4.2,4.2,0,0,0,5.37,2.49l83.37-30.56A4.2,4.2,0,0,0,768.39,516.12Z",
    transform: "translate(-8 -66.84)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ad365119-15e7-40b8-b95e-e91aa2eee38a",
    "data-name": "flag"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac414359-6e96-4e5f-8718-d104cef9c6f5",
    "data-name": "flag_part",
    className: "a9acf446-bb36-4ff5-b274-7615b4835329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a82e72be-c2f4-4c78-a117-bdba0c778d90",
    "data-name": "back_f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bbc21f56-3242-4f18-a05a-9faeb9af38d2",
    "data-name": "back_f_1",
    className: "ae9a7081-23be-4ed3-91ca-bb295fde1efd",
    d: "M1819.54,767.32l-2.12-111.46a14.76,14.76,0,0,0,1.06,5.34,14.42,14.42,0,0,0,3.19,4.74c10.38,10.4,39.52,11.45,86.86,3.16l2.13,111.45c-47.35,8.3-76.48,7.24-86.87-3.15a14.35,14.35,0,0,1-3.19-4.75A14.75,14.75,0,0,1,1819.54,767.32Z",
    transform: "translate(-8 -66.84)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bec036e7-d880-463d-bb85-fafd205bd0cd",
    "data-name": "shadow_f",
    className: "f9da365f-698a-4313-a061-67cbdc308e5f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b997d7a7-6a37-4a71-8b8b-7c595b2f0a07",
    "data-name": "shadow_f_path",
    d: "M1819.54,767.32l-2.12-111.46a14.76,14.76,0,0,0,1.06,5.34,14.42,14.42,0,0,0,3.19,4.74c10.38,10.4,39.52,11.45,86.86,3.16l2.13,111.45c-47.35,8.3-76.48,7.24-86.87-3.15a14.35,14.35,0,0,1-3.19-4.75A14.75,14.75,0,0,1,1819.54,767.32Z",
    transform: "translate(-8 -66.84)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "b140359a-8b06-4076-bf08-7a09fa494ec9",
    "data-name": "front_f",
    className: "ae9a7081-23be-4ed3-91ca-bb295fde1efd",
    d: "M1819.54,639.37l2.12,111.45a15,15,0,0,0-4.49-10.67c-10.79-10.8-40.39-11.09-90-.91L1725,627.79c49.65-10.19,79.25-9.9,90,.9a15.65,15.65,0,0,1,3.19,4.6A15.33,15.33,0,0,1,1819.54,639.37Z",
    transform: "translate(-8 -66.84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a80606d1-f5c2-4d81-b652-bde70ca6f1ac",
    "data-name": "line"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a9104a1f-e19b-4286-b2e8-cb0fc1455121"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 20,
    transform: "translate(1715 543.16)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAUCAYAAAC07qxWAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQoU2NkyDD/z0AEYCKkAAZGFeIFowrxgqGgEABsNgHG+jIyKAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 391,
    transform: "translate(1715 561.16)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("g", {
    className: "efeda1ec-0cb8-4457-ba2c-81f46cab70c6"
  }, /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 19,
    transform: "translate(1715 951.16)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAATCAYAAACp65zuAAAACXBIWXMAAAsSAAALEgHS3X78AAAANUlEQVQoU+3KIRIAIBBCUcD7H1mw6IxpNRj9BcJjEtimpOwbgE1yn59JcJNOYPVh2Ydl7+EALm8XGQtLOOAAAAAASUVORK5CYII="
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgility);
export default __webpack_public_path__ + "static/media/agility.aa0502fb79018afb264297e1c26febe4.svg";
export { ForwardRef as ReactComponent };